export const routes = [
  {
    path: '/:all(.*)',
    name: '404',
    component: () => import('/Users/gyf/company/frontend_broker/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/Broker',
    /* internal name: '/Broker' */
    /* no component */
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('/Users/gyf/company/frontend_broker/src/pages/Broker/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Saque',
    /* internal name: '/Saque' */
    /* no component */
    children: [
      {
        path: '',
        name: 'SaquesIndex',
        component: () => import('/Users/gyf/company/frontend_broker/src/pages/Saque/index.vue'),
        /* no children */
      },
      {
        path: 'childrenView',
        /* internal name: '/Saque/childrenView' */
        /* no component */
        children: [
          {
            path: 'SaquesApostasDetalhes',
            name: 'SaquesApostasDetalhes',
            component: () => import('/Users/gyf/company/frontend_broker/src/pages/Saque/childrenView/SaquesApostasDetalhes.vue'),
            /* no children */
          },
          {
            path: 'SaquesCard',
            name: 'SaquesCard',
            component: () => import('/Users/gyf/company/frontend_broker/src/pages/Saque/childrenView/SaquesCard.vue'),
            /* no children */
          },
          {
            path: 'SaquesList',
            name: 'SaquesList',
            component: () => import('/Users/gyf/company/frontend_broker/src/pages/Saque/childrenView/SaquesList.vue'),
            /* no children */
          },
          {
            path: 'SaquesTarefas',
            name: 'SaquesTarefas',
            component: () => import('/Users/gyf/company/frontend_broker/src/pages/Saque/childrenView/SaquesTarefas.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'details',
        /* internal name: '/Saque/details' */
        /* no component */
        children: [
          {
            path: 'saquesDetails',
            name: 'SaquesDetails',
            component: () => import('/Users/gyf/company/frontend_broker/src/pages/Saque/details/saquesDetails.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/SaqueSetting',
    /* internal name: '/SaqueSetting' */
    /* no component */
    children: [
      {
        path: '',
        name: 'SaqueSetting',
        component: () => import('/Users/gyf/company/frontend_broker/src/pages/SaqueSetting/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/unocss',
    /* internal name: '/unocss' */
    /* no component */
    children: [
      {
        path: '',
        name: 'UnoCSS',
        component: () => import('/Users/gyf/company/frontend_broker/src/pages/unocss/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/vendorearch',
    /* internal name: '/vendorearch' */
    /* no component */
    children: [
      {
        path: '',
        name: 'vendorearch',
        component: () => import('/Users/gyf/company/frontend_broker/src/pages/vendorearch/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/vendorearch/details' */
        /* no component */
        children: [
          {
            path: 'testsearch',
            name: 'testsearch',
            component: () => import('/Users/gyf/company/frontend_broker/src/pages/vendorearch/details/testsearch.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/withdrawal-history',
    /* internal name: '/withdrawal-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'WithdrawalHistory',
        component: () => import('/Users/gyf/company/frontend_broker/src/pages/withdrawal-history/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

